var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisagreeColour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Disagree_Colour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Evaluation_OpinionScale-(Slider-active---Disagree)",
    transform: "translate(-101.000000, -351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selectors/OpinionScale",
    transform: "translate(16.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration/Disagree",
    transform: "translate(85.039305, 109.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2A870",
    cx: 20.9606952,
    cy: 20.9606952,
    r: 20.9606952
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.642615,35.9177487 C0.861898396,41.9207166 0.382042781,11.9166578 12.9644118,1.58072727 C5.3554492,4.72387701 0.000336898397,12.2161604 0.000336898397,20.9603583 C0.000336898397,32.5364118 9.38464171,41.9207166 20.9606952,41.9207166 C26.6787594,41.9207166 31.8609305,39.6301444 35.642615,35.9177487 Z",
    id: "Path",
    fill: "#ABABAB",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(9.576857, 17.743316)",
    fill: "#495059",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 11.4040523,
    cy: 4.65806952,
    rx: 2.85060963,
    ry: 3.47589305
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64907368,4.85975936 C2.18392929,4.85975936 1.80682769,4.48265775 1.80682769,4.01751337 L1.80682769,2.56413369 C1.80682769,2.0989893 2.18392929,1.7218877 2.64907368,1.7218877 C3.11421806,1.7218877 3.49131967,2.0989893 3.49131967,2.56413369 L3.49131967,4.01751337 C3.49131967,4.48277005 3.11421806,4.85975936 2.64907368,4.85975936 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1600416,4.85975936 C19.6948972,4.85975936 19.3177956,4.48265775 19.3177956,4.01751337 L19.3177956,2.56413369 C19.3177956,2.0989893 19.6948972,1.7218877 20.1600416,1.7218877 C20.625186,1.7218877 21.0022876,2.0989893 21.0022876,2.56413369 L21.0022876,4.01751337 C21.0022876,4.48277005 20.6252983,4.85975936 20.1600416,4.85975936 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.30717528,2.69451337 C4.23496673,2.69451337 4.16163518,2.68508021 4.08864052,2.66565241 L0.714715389,1.76152941 C0.265405229,1.64114439 -0.00119370172,1.17925668 0.119191325,0.729946524 C0.239688651,0.280636364 0.701688651,0.014486631 1.15077421,0.13442246 L4.52469935,1.03854545 C4.97400951,1.15893048 5.24060844,1.62081818 5.12022341,2.07012834 C5.01937849,2.44633155 4.67899881,2.69451337 4.30717528,2.69451337 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.50194,2.69451337 C18.1300042,2.69451337 17.7897368,2.44633155 17.6888919,2.07001604 C17.5685068,1.62070588 17.8351058,1.15881818 18.2844159,1.03843316 L21.6583411,0.13431016 C22.1077635,0.0141497326 22.5694266,0.280636364 22.6899239,0.729834225 C22.810309,1.17914439 22.54371,1.64103209 22.0943999,1.76141711 L18.7204747,2.66554011 C18.6474801,2.68508021 18.5741485,2.69451337 18.50194,2.69451337 L18.50194,2.69451337 Z",
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisagreeColour);
export default __webpack_public_path__ + "static/media/Disagree_Colour.1b6f8f8ddf3e9021e921ca1f7c5d04b8.svg";
export { ForwardRef as ReactComponent };